export default __webpack_public_path__ + "static/gallery6-a11cde7d1df78370c3fbef2f9ed64b00.png";